import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Circle Fill Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M253.44 128c0 96.564-104.533 156.916-188.16 108.634s-83.627-168.986 0-217.268A125.44 125.44 0 0 1 128 2.56c69.243.086 125.354 56.197 125.44 125.44" }, null, -1)
  ]))]))
}
export default { render: render }